/**
 * 配列を無限ループさせる関数を作成する
 * @param {Array} seedAry 無限ループさせたい配列
 */
export function arrayToRepeater(seedAry) {
  const iterator = (function* i() {
    let index = 0
    while (true) {
      yield seedAry[index]
      index++
      if (index === seedAry.length) index = 0
    }
  })()
  return () => iterator.next().value
}
